import React from 'react';
import { useStyles } from '~atoms/BetslipKeyboardButtons/BetslipKeyboardButtons.styles';
export var KeyboardButton = function (_a) {
    var value = _a.value, icon = _a.icon, onClick = _a.onClick;
    var classes = useStyles();
    return (React.createElement("div", { role: "button", tabIndex: 0, className: classes.mainBoardButton, onClick: onClick },
        React.createElement("span", null, value),
        icon));
};
